export const newsletters = Object.freeze([
	Object.freeze({
		name: 'Discover Magazine',
		description:
			'Feed your curiosity with the latest science news delivered to your inbox weekly.',
		code: 'DSC'
	})
])
